import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.checkSession()) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};

export function permissionGuard(requiredPerms: string | string[]): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.checkSession()) {
      router.navigate(['/login']);
      return false;
    }

    if (auth.isSuperAdmin) return true;

    const perms = Array.isArray(requiredPerms) ? requiredPerms : [requiredPerms];
    const hasAccess = auth.hasAnyPermission(perms);

    if (!hasAccess) {
      console.warn(`Access denied to route: requires [${perms.join(', ')}]`);
      router.navigate(['/dashboard']);
      return false;
    }

    return true;
  };
}

